import React from 'react';
import { InfoIcon } from 'lucide-react';
import { floorCalendar } from '../../data/floorCalendar';
import { dateLabel } from '../../utils/floor';
export function DataSourceNotice() {
  return <div role="note" className="flex items-start gap-3 rounded-xl border border-bright/20 bg-bright/5 px-4 py-3 text-[13px]" data-id="element-181" data-mp="rd1rirql1cdi">
      <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-bright" aria-hidden data-id="element-182" data-mp="w53b6yq2y5dk" />
      <p className="text-ink" data-id="element-183" data-mp="106olccb8c5k2">
        <span className="font-semibold" data-id="element-184" data-mp="105df85ubalps">From Five9's daily agent state report, not real time.</span>{' '}
        <span className="text-muted" data-id="element-185" data-mp="1535935eiohwm">
          Latest report covers {dateLabel(floorCalendar.max)} · refreshed {floorCalendar.refreshedAt}. Today's floor time appears tomorrow morning.
        </span>
      </p>
    </div>;
}